export default __webpack_public_path__ + "static/media/Modelo 2.6aeea73c.png";